/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import { object, string } from 'prop-types';
import { compose } from 'recompose';
import { useUIDSeed } from 'react-uid';

import { getBrand } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { GRAPHQL_ENV } from '../../../../../../gql';
import GraphqlPortalLoader from '../../../../GraphqlCommonComponents/GraphqlPortalLoader';

import ContentPageBlock from '../../../../GraphqlContentPage/ContentPageBlock';
import findContentPage from '../../../../../../gql/queries/findContentPage';

const GraphqlWineRestrictions = ({ brand, path }) => {
    const CONTENTPAGE_QUERY = findContentPage(brand['domain-name'], path);
    const seed = useUIDSeed();
    return (
        <Query query={CONTENTPAGE_QUERY}>
            {({ loading, error, data }) => {
                let response = null;
                if (loading) {
                    response = <GraphqlPortalLoader />;
                } else if (error) {
                    mbpLogger.logError({
                        query: CONTENTPAGE_QUERY,
                        component: 'GraphqlContentPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });

                    response = null;
                } else if (!data) {
                    mbpLogger.logWarning({
                        query: CONTENTPAGE_QUERY,
                        component: 'GraphqlContentPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });

                    response = null;
                } else if (!data?.findContentPage?.content) {
                    mbpLogger.logWarning({
                        query: CONTENTPAGE_QUERY,
                        component: 'GraphqlContentPage.js',
                        message: 'No content returned for query',
                    });
                    response = null;
                } else if (data?.findContentPage?.content?.entries.length === 0) {
                    response = <h4>This content is not available right now. Please try again later.</h4>;
                } else {
                    const pageBlocks = data.findContentPage.content.entries?.[0] || null;

                    response =  (
                        pageBlocks?.center_blocks?.map((block, index) => (
                            <ContentPageBlock
                                block={block}
                                key={seed(block, index)}
                                ssrDeviceType="mobile"
                                identifyWidthObj={{
                                    isMobile: true,
                                    isDesktop: false,
                                }}
                            />
                        ))
                    );
                }
                return response;
            }}
        </Query>
    );
};

GraphqlWineRestrictions.propTypes = {
    brand: object.isRequired,
    path: string.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
);

export default enhance(GraphqlWineRestrictions);
